import {StopLocation} from './timecard-detail-view.type';
import {TimeCardEntryType} from './timecard-entry-type.type';
import {Address} from '../../addresses/models/address.model';
import {TimeCardHistoryItem} from '../angular/models/timecard-history.model';
export {TimeCardEntryType};

export interface EditEntryDialogData {
  stopName: string;
  arrival: number | null;
  departure: number | null;
  serviceTime: number;
  plannedArrival?: number | null;
  plannedDeparture?: number | null;
  plannedServiceTime?: number;
  passiveTrackingServiceTime?: number;
  distance?: number;
  siteDistanceUnit?: string;
  editMode?: 'arrival' | 'departure' | 'serviceTime' | 'distance';
  initialArrival?: number | null;
  initialDeparture?: number | null;
  clockInTime?: number;
  clockOutTime?: number;
}

export interface EditEntryDialogResult {
  arrival: number | null;
  departure: number | null;
  serviceTime: number;
  distance?: number;
}

export interface EditAdminTimeShiftRow {
  timeCardId: string;
  shiftName: string;
  adminTime: number;
  isLocked: boolean;
}

export interface EditAdminTimeChange {
  timeCardId: string;
  adminTime: number;
}

export interface EditAdminTimeDialogData {
  title: string;
  shifts: EditAdminTimeShiftRow[];
  onOpenHistory?: (timeCardId: string) => void;
}

export interface EditAdminTimeDialogResult {
  changes: EditAdminTimeChange[];
}

export interface TimecardEntryOption {
  accountId: string;
  startTime: number;
  endTime: number;
  type?: string;
  archive?: boolean;
}

export interface TimecardBreakOption {
  id: string;
  breakTypeId?: string;
}

export interface TimecardOption {
  id: string;
  shiftNumber: number;
  shiftName: string;
  clockInTime: number;
  clockOutTime: number;
  status: string;
  entries?: TimecardEntryOption[];
  // Entry types that exist in this timecard (for blocking options in dropdown)
  entryTypes?: string[];
  // Existing breaks in this timecard (for duplicate break type risk detection)
  breaks?: TimecardBreakOption[];
}

export interface AddStopDialogData {
  // Reference date for the timecard (for time picker)
  referenceDate: number;
  // The user's selected timezone - times are entered and shown in it
  zoneId?: string;
  // Available timecards to select from
  timecards?: TimecardOption[];
  // Pre-selected timecard ID (optional)
  selectedTimecardId?: string;
  // Agent's registered address (for pre-filling Start/End Location)
  agentAddress?: Address;
  // Agent id (used to fetch break types relevant for this agent)
  agentId?: string;
}

export interface HistoryLogDialogData {
  timeCardId: string;
  historyData?: TimeCardHistoryItem[];  // Pre-fetched history data (optional)
  filterField?: string;  // Field name to filter by (e.g., 'serviceTime', 'startTime', 'status')
  filterEntryId?: string;  // Entry ID to filter by specific stop
  filterStopName?: string;  // Stop name for filter indicator display
  filterEntryIndex?: number;  // 1-based entry index for correct stop numbering
  isSensitiveLocationEntry?: boolean;
}

export interface ExportPayrollDialogResult {
  completeApproved: boolean;
  archiveNotApproved: boolean;
}

export interface MondelezSummaryDialogResult {
  from: number;
  to: number;
  zoneId: string;
}

export interface PayrollExportRecoveryDialogData {
  batchId: string;
  stalled: boolean;
}

export interface AddStopDialogResult {
  accountId?: string;
  accountName?: string;
  arrival?: number;
  departure?: number;
  location: StopLocation;
  // Selected timecard ID
  timecardId: string;
  // Flag to indicate if we're updating existing entry instead of adding new
  isUpdateExisting: boolean;
  // Index of existing entry to update (if isUpdateExisting is true)
  existingEntryIndex?: number;
  // Entry type for the stop (Task, AgentStartLocation, AgentEndLocation, Break)
  stopType: TimeCardEntryType;
  serviceTime?: number;
  // Break type id and its paid flag (only for Break stopType)
  breakTypeId?: string;
  breakTypePaid?: boolean;
}
